"use client";
import { useQuery } from "@tanstack/react-query";
import { useFetchWrapper } from "modules/common/hooks/useFetchWrapper";
import { QUERIES } from "modules/common/query";
import { API_ROUTES } from "utils/api-route.constants";
import { STATIC_DATA_CONFIG } from "modules/common/react-query-configs";
import { CardCityAvailability } from "modules/cards/model/card";

export function useCardCities(
  game: string,
  setCode: string,
  cardNumber: string,
  cardId?: string
) {
  const fetch = useFetchWrapper();

  const query = useQuery<CardCityAvailability>({
    queryKey: [QUERIES.CARD_CITIES, setCode, cardNumber, cardId, game],
    queryFn: () =>
      fetch.publicGet(
        API_ROUTES.TRADE.CARD_CITIES(setCode, cardNumber, game, cardId),
        null
      ),
    enabled: !!game && !!setCode && !!cardNumber,
    ...STATIC_DATA_CONFIG, // 30min stale time
    // Always reconcile the ISR snapshot against the shared two-minute edge
    // entry. Existing data stays visible while this background read runs.
    refetchOnMount: "always",
  });

  return {
    query,
    cities: query.data?.cities || [],
    // isLoading, not isFetching: consumers read this as "no data yet", and a
    // background refetch would otherwise flip them back to a loading state.
    // isLoading (rather than isPending) stays false while the query is disabled.
    isLoading: query.isLoading,
    error: query.error,
  };
}
